import React, { useMemo, useState } from "react";
import styled from "styled-components";
import {
  buildLegendAccordionPayload,
  buildRadialMatrix,
  buildTPILevelMetrics,
} from "./util";

import {
  ElementContainer,
  FlexibleContainer,
  RowContainer,
} from "../../../components/containers/styledComponents";

import { PublicMetric } from "../../../models/CompanyprofileModels";
import { RadialBarChart } from "./TPIRadial";
import { TPIManagementScoreBar } from "./TPIManagementScoreBar";
import { TPILegendAccordionItem } from "./TPILegendAccordionItem";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { greyText } from "../../../styles";
import { MANAGEMENT_QUALITY_TITLE } from "./constants";

const LegendTopContainer = styled.div`
  display: flex;
  flex: 3;

  padding: 10px;
  border-radius: 8px;
  align-self: stretch;
`;

export const TabTPI = ({
  metricsData,
}: {
  metricsData: PublicMetric[];
}): JSX.Element => {
  const [selectedLevel, setSelectedLevel] = useState<number | null>(null);
  const levelsMatrix = useMemo(
    () => buildRadialMatrix(metricsData),
    [metricsData]
  );

  const accordionPayload = useMemo(() => {
    const levelMetrics = buildTPILevelMetrics(metricsData);
    return buildLegendAccordionPayload(levelMetrics);
  }, [metricsData]);

  return (
    <FlexibleContainer fd="column" w="100%" p="10px 5px" ofy="auto" fw="wrap">
      <RowContainer mb={24}>
        <ElementContainer flexDirection="column" ai="flex-start" jc="center">
          <CompassParagraph bold={true} fontSize={14}>
            Management Quality
          </CompassParagraph>
          <CompassParagraph color={greyText}>
            {MANAGEMENT_QUALITY_TITLE}
          </CompassParagraph>
        </ElementContainer>
      </RowContainer>
      <TPIManagementScoreBar metricsData={metricsData} />

      <FlexibleContainer fd="row" h="350px" w="100%" ofx="auto">
        <LegendTopContainer>
          <FlexibleContainer
            w="100%"
            fd="column"
            ai="flex-start"
            jc="flex-start"
            ofy="auto"
          >
            {accordionPayload.map((item) => (
              <TPILegendAccordionItem
                key={item.level}
                isActive={selectedLevel === item.level}
                setActiveLevel={setSelectedLevel}
                level={item.level}
                color={item.color}
                title={item.title}
                questions={item.questions}
              />
            ))}
          </FlexibleContainer>
        </LegendTopContainer>

        <RadialBarChart
          levelsMatrix={levelsMatrix}
          activeLevel={selectedLevel}
          setActiveLevel={setSelectedLevel}
        />
      </FlexibleContainer>
    </FlexibleContainer>
  );
};
